import { type FC, type ReactElement } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
	message: string;
	placement?: 'top' | 'bottom' | 'right' | 'left';
	children: ReactElement;
}

const ButtonTooltip: FC<Props> = (props) => {
	const { message, placement = 'top', children } = props;

	return (
		<OverlayTrigger overlay={<Tooltip id="tooltip">{message}</Tooltip>} placement={placement}>
			{children}
		</OverlayTrigger>
	);
};

export default ButtonTooltip;
